import {Component, EventEmitter, OnInit, Output} from '@angular/core';


@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ]
})
export class AppComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/app.component.ts